import styles from './Login.module.css';

import React, { useState } from 'react';

import FormLayout from './FormLayout';
import { isEmailFormatValid } from './authHelpers';
import PasswordField from './PasswordField';

interface LoginFormProps {
  onSubmit: (email: string, password: string) => void;
  onForgotPassword: (email: string) => void;
  loading: boolean;
  errorMessage: string;
  message: string;
}

const LoginForm: React.FC<LoginFormProps> = ({
  onSubmit,
  onForgotPassword,
  loading,
  errorMessage,
  message
}) => {

  const [email, setEmail] = useState<string>('');
  const [emailError, setEmailError] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [isValid, setIsValid] = useState<boolean>(false);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement> | React.MouseEvent<HTMLButtonElement>): void => {
    e.preventDefault();
    if (!isValid) {
      return;
    }
    onSubmit(email, password);
  };

  const handleEmailBlur = (email: string): void => {
    if (!isEmailFormatValid(email)) {
      setEmailError('Please enter a valid email address.');
    } else {
      setEmailError('');
    }
  };

  const handleEmailChange = (email: string): void => {
    setEmail(email);
    if (isEmailFormatValid(email)) {
      setEmailError('');
    }
  };

  const handleForgotPassword = (e: React.MouseEvent<HTMLAnchorElement>): void => {
    e.preventDefault();
    onForgotPassword(email);
  };

  React.useEffect(() => {
    setIsValid(isEmailFormatValid(email) && password.length > 0);
  }, [email, password]);

  return (
    <FormLayout
      title="Sign In"
      errorMessage={errorMessage}
      message={message}
    >
      <div>
        <form onSubmit={handleSubmit}>
          <div className={styles['form-field']}>
            <div className={styles['login-field-label-row']}>
              <label className={styles['label-login-field']} htmlFor="email">Email: <span className={styles['label-required-star']}>*</span></label>
            </div>
            <div>
              <input
                className={styles['input-login-field']}
                id="email"
                data-testid="email-input"
                type="email"
                value={email}
                onBlur={e => handleEmailBlur(e.target.value)}
                onChange={e => handleEmailChange(e.target.value)}
                placeholder="example@hospital.com"
                required
              />
            </div>
            {emailError && <div className={styles['login-error-message']}>{emailError}</div>}
          </div>

          <PasswordField
            label="Password:"
            onForgotPassword={handleForgotPassword}
            onPasswordChange={(pwd: string) => setPassword(pwd)}
            showError={false}
          />
        </form>
      </div>

      <div className={styles['login-action-container']}>
        <button
          type="submit"
          className={styles['login-submit-btn']}
          data-testid="submit-btn"
          disabled={(loading || !isValid)}
          onClick={handleSubmit}
        >
          Sign In
        </button>
      </div>
    </FormLayout>
  );
};

export default LoginForm;
